import { APM_ENVIRONMENT, APM_SERVER_URL, APM_SERVICE_NAME_FRONT, apiMessageUrl, apiUrl } from "../../../shared/Config";

function normalizeServerUrl(value: string): string {
  const trimmed = (value || "").trim();
  if (!trimmed) return "";
  return trimmed.endsWith("/") ? trimmed : `${trimmed}/`;
}

const serverUrl = normalizeServerUrl(APM_SERVER_URL);

export const apmConfig = {
  serviceName: APM_SERVICE_NAME_FRONT || "mm-core-user-management-frontend",
  serverUrl,
  environment: APM_ENVIRONMENT || "local",
  distributedTracingOrigins: [apiUrl, apiMessageUrl].filter(Boolean),
  propagateTracestate: true,
  transactionSampleRate: 1.0,
  initialPageLoadName: "app-initial-load",
  apmRequestTimeout: 10000,
  captureErrors: true,
  captureExceptions: true,
  captureUserClick: true,
  ...(process.env.NODE_ENV !== "production" ? ({ logLevel: "debug" as const } as const) : {}),
};

